import { ItemType } from "../../model/datasource/item";

export class BindRecord<T extends HTMLElement = HTMLElement> {
	bindCallback = (html: T, event: Event): (Event | Event[]) => [];
	targets: NodeList | EventTarget[];
	listen: string;
	invoke: BindRecord<T>['bindCallback'];
	suppress: boolean;

	constructor(targets: NodeList | EventTarget[], listen: string, invoke: BindRecord<T>['bindCallback'], suppress?: boolean) {
		this.targets = targets;
		this.listen = listen;
		this.invoke = invoke;
		this.suppress = suppress || false;
	}

	bind(bindTarget: EventTarget): void {
		this.targets.forEach(element => {
			element.addEventListener(this.listen, e => {
				if (this.suppress) { e.preventDefault(); }
				const event = this.invoke(element, e);
				if (Array.isArray(event)) {
					event.forEach(e => bindTarget.dispatchEvent(e));
				} else {
					bindTarget.dispatchEvent(event);
				}
				return false;
			});
		});
	}
}

type conditionCallback = (key: string, answers: NodeListOf<HTMLInputElement>, type: ItemType) => boolean;
type invokeCallback = (answers: NodeListOf<HTMLInputElement>, type: ItemType) => Event;
export class KeyBindRecord {
	condition: conditionCallback;
	invoke: invokeCallback;
	suppress: boolean;

	constructor(condition: conditionCallback, invoke: invokeCallback, suppress?: boolean) {
		this.condition = condition;
		this.invoke = invoke;
		this.suppress = suppress || false;
	}
}

